<template>
  <van-col class="list-item" span="12" @click="navDetail(itemInfo.id)">

    <van-image width="100%" :src="itemInfo.picUrl" />

    <!-- <img :src="itemInfo.picUrl"> -->

    <p class="item-name">{{itemInfo.name}}</p>
    <p class="item-price">￥{{itemInfo.retailPrice}}</p>
  </van-col>
</template>

<script>
export default {
  name: "itemInfo",
  components: {},
  data() {
    return {
      newList: "",
      title: "",
    };
  },
  props: ["itemInfo", "titleMsg"],
  created() {},
  activated() {},
  mounted() {},
  methods: {
    navDetail(id) {
      this.$emit("navDetail", id);
    },
  },
};
</script>

<style lang="scss" scoped>
.list-item {
  // height: 25.5rem;
  display: inline-block;
  padding: 0.4rem 0 0.4rem 0.4rem;

  background: #fff;

  img {
    // width: auto;
    // height: 16rem;
    border-radius: 5px;
  }
  // margin: 0.4rem 0.2rem 0 0.4rem;
  // width: 48%;
  // border: 3px solid #f4f4f4;

  .item-name {
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    width: 100%;
    font-size: 1.4rem;
    height: 4rem;
    text-align: left;
    margin: 0.5rem 0;
    padding-left: 0.5rem;
    box-sizing: border-box;
  }
  .item-price {
    font-size: 1.6rem;
    text-align: left;
    height: 2rem;
    line-height: 2rem;
    margin: 0;
    font-family: PingFangSC-Semibold;
    font-size: 1.4rem;
    color: red;
    letter-spacing: 0.29px;
    line-height: 1.4rem;
    padding-left: 0.5rem;
    box-sizing: border-box;
  }
}
.list-item:nth-child(odd) {
  padding: 0.4rem 0.4rem 0.4rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/itemInfo.vue